import { EmptyState, Icons } from "@dms/ui";
import { useLocation } from "react-router-dom";

// Тимчасова сторінка для nav-розділів, чиї екрани реалізуються у наступних фічах.
export function PlaceholderPage({ title }: { title?: string }) {
  const location = useLocation();
  return (
    <div style={{ paddingTop: 40 }}>
      <EmptyState
        icon={<Icons.layers size={26} />}
        title={title ?? "Розділ"}
        description={
          <>
            Цей екран зʼявиться в наступних релізах. Маршрут:{" "}
            <code style={{ fontFamily: "var(--font-mono)" }}>{location.pathname}</code>
          </>
        }
      />
    </div>
  );
}
